import React from 'react';
import { connect } from 'react-redux';
import styles from './nav-bar.scss';
import PropTypes from 'prop-types';
import { requestTabChange } from '../../actions/index';
import * as selectors from '../../reducers';
import { gaTracking } from '../../modules/ga';

const pages = ['By Cluster', 'By Priority', 'By Budget'];

class NavBar extends React.Component {
  constructor() {
    super();
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleButtonClick(tab) {
    const { activeTab } = this.props;
    if (activeTab === tab) return;
    return () => {
      this.props.requestTabChange(tab);
      gaTracking('Navigation button click', {
        event_label: tab,
      });
    };
  }

  renderButtons() {
    const { tabRequested } = this.props;
    return pages.map(page => {
      return (
        <button
          key={page}
          className={`${styles.navButton} ${page === tabRequested
            ? styles.navButtonSelected
            : ''}`}
          type="button"
          onClick={this.handleButtonClick(page)}
        >
          {page}
        </button>
      );
    });
  }

  render() {
    const { tabRequested } = this.props;
    return (
      <div className={styles.navRow}>
        <button
          className={`${styles.bubbleButton} ${tabRequested === 'overview'
            ? styles.bubbleButtonActive
            : styles.bubbleButtonInactive}`}
          onClick={this.handleButtonClick('overview')}
        />
        {this.renderButtons()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activeTab: selectors.getActiveTab(state),
  tabRequested: selectors.getRequestedTab(state),
});

const mapDispatchToProps = {
  requestTabChange,
};

NavBar.propTypes = {
  activeTab: PropTypes.string,
  tabRequested: PropTypes.string,
  requestTabChange: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);



// WEBPACK FOOTER //
// ./src/components/nav-bar/nav-bar.js